import {ENDPOINT_ALLOCATION} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';
import _ from 'lodash';

const getAllocation = (token, allocationId) => {
  return fetch(`${ENDPOINT_ALLOCATION}${allocationId}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getAllocationsByStatusAndIds = ({status, allocations}) => {
  let allocationIds = _.join(_.map(allocations, 'allocationId'), ',');

  return fetch(`${ENDPOINT_ALLOCATION}status/${status}/allocationIds/${allocationIds}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getAllocationsByFoId = ({foId}) => {
  return fetch(`${ENDPOINT_ALLOCATION}fundingOpportunityId/${foId}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

export default {
  getAllocation,
  getAllocationsByStatusAndIds,
  getAllocationsByFoId,
};
